export default [
    {
        component: () => import(
            /* webpackChunkName: 'ambulatorio-acolhimento-acs-tacs' */
            '@/views/ambulatorio/acolhimento-acs-tacs/Index'
        ),
        path: 'acolhimento-acs-tacs',
        redirect: 'acolhimento-acs-tacs/index',
        children: [
            {
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-acolhimento-acs-tacs' */
                    '@/views/ambulatorio/acolhimento-acs-tacs/List.vue'
                ),
                name: 'ambulatorio-acolhimento-acs-tacs-index',
                path: 'index',
            },
            {
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-acolhimento-acs-tacs' */
                    '@/views/ambulatorio/acolhimento-acs-tacs/Form.vue'
                ),
                name: 'ambulatorio-acolhimento-acs-tacs-create',
                path: 'create/:filaId',
                props: route => ({
                    filaId: parseInt(route.params.filaId),
                }),
            },
        ],
    },
]